import { render, staticRenderFns } from "./ApplyTemplateToDisplays.vue?vue&type=template&id=10ca1a16"
import script from "./ApplyTemplateToDisplays.vue?vue&type=script&lang=js"
export * from "./ApplyTemplateToDisplays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports